import { defineMessage } from "react-intl";

export const PLACES_TYPES_VALUE_PLACE = "place";
export const PLACES_TYPES_VALUE_SCHOOL = "school";

export const PLACES_TYPES = {
  [PLACES_TYPES_VALUE_PLACE]: {
    value: PLACES_TYPES_VALUE_PLACE,
    label: defineMessage({ defaultMessage: "Autre" }),
  },
  [PLACES_TYPES_VALUE_SCHOOL]: {
    value: PLACES_TYPES_VALUE_SCHOOL,
    label: defineMessage({ defaultMessage: "École" }),
  },
};

export const PLACES_TYPES_LIST = Object.values(PLACES_TYPES);

// ============================================================

export const PLACES_SORT_VALUE_NAME_ASC = "name_asc";
export const PLACES_SORT_VALUE_NAME_DESC = "name_desc";
export const PLACES_VALUE_DATE_ASC = "created_asc";
export const PLACES_VALUE_DATE_DESC = "created_desc";

export const PLACES_SORTS = {
  [PLACES_SORT_VALUE_NAME_ASC]: {
    id: PLACES_SORT_VALUE_NAME_ASC,
    message: defineMessage({ defaultMessage: "Nom (A-Z)" }),
  },
  [PLACES_SORT_VALUE_NAME_DESC]: {
    id: PLACES_SORT_VALUE_NAME_DESC,
    message: defineMessage({ defaultMessage: "Nom (A-Z)" }),
  },
  [PLACES_VALUE_DATE_ASC]: {
    id: PLACES_VALUE_DATE_ASC,
    message: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [PLACES_VALUE_DATE_DESC]: {
    id: PLACES_VALUE_DATE_DESC,
    message: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
};

export const PLACES_SORT_LIST = Object.values(PLACES_SORTS);
